export default __webpack_public_path__ + "static/media/treasurer_logo.85e4d13f.png";